import EmptyState from '@atlaskit/empty-state';
import SectionMessage from '@atlaskit/section-message';
import React, { useEffect, useState } from 'react';
import GenericErrorImage from "../../../../common/components/generic-error.svg";
export default function ErrorMessage(props) {
  const [errorMessages, setErrorMessages] = useState([]);
  useEffect(() => {
    if (props.error && !(props.error instanceof Error)) {
      props.error.json().then(({
        errors
      }) => {
        setErrorMessages(errors);
      }).catch(console.error.bind(console));
    }
  }, [props.error]);
  return props.status === 400 ? /*#__PURE__*/React.createElement(SectionMessage, {
    title: "There was a problem retrieving this data. Please check the values and try again.",
    appearance: "error"
  }, errorMessages.length > 0 && /*#__PURE__*/React.createElement("ul", null, errorMessages.map(errorMessage => /*#__PURE__*/React.createElement("li", {
    key: errorMessage.message
  }, errorMessage.message)))) : /*#__PURE__*/React.createElement(EmptyState, {
    header: "We ran into a little trouble",
    description: "It might just be a hiccup. Try again in a bit.",
    imageUrl: GenericErrorImage
  });
}